"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IntegrationLog () {
        return IntegrationLog;
    },
    get IntegrationLogCsvProperties () {
        return IntegrationLogCsvProperties;
    },
    get IntegrationLogProperties () {
        return IntegrationLogProperties;
    },
    get IntegrationLogSftpProperties () {
        return IntegrationLogSftpProperties;
    },
    get IntegrationLogUserUpdates () {
        return IntegrationLogUserUpdates;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _integration = require("./integration");
const IntegrationLogUserUpdates = _zod.z.object({
    userID: _zod.z.instanceof(_bson.ObjectId),
    insertedCount: _zod.z.number(),
    uniqueFieldUpdateCount: _zod.z.number(),
    updatedFields: _zod.z.object({
        updatedFields: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.any()))
    }),
    hasError: _zod.z.boolean(),
    error: _zod.z.object({
        code: _zod.z.string(),
        message: _zod.z.string()
    }).or(_zod.z.null()),
    updatesFound: _zod.z.boolean(),
    userNotFound: _zod.z.boolean().optional(),
    created: _zod.z.instanceof(_bson.ObjectId).or(_zod.z.string())
});
const IntegrationLogSftpProperties = _zod.z.object({
    source_key: _zod.z.string(),
    source_bucket: _zod.z.string(),
    archive_key: _zod.z.string(),
    archive_bucket: _zod.z.string(),
    sftp_integration_config_id: _zod.z.instanceof(_bson.ObjectId),
    testing_mode: _zod.z.boolean()
});
const IntegrationLogCsvProperties = _zod.z.object({
    field_mapping_object: _zod.z.record(_zod.z.string(), _zod.z.unknown()),
    field_map_used: _zod.z.record(_zod.z.string(), _zod.z.instanceof(_bson.ObjectId)),
    csv_hash: _zod.z.string().optional(),
    num_users_in_csv: _zod.z.number().optional(),
    num_fields_in_csv: _zod.z.number().optional(),
    csv_fields_to_skip: _zod.z.array(_zod.z.string()).optional()
});
const IntegrationLogProperties = _zod.z.object({
    /** List of objects representing the history of the job run. */ breadcrumbs: _zod.z.array(_zod.z.object({
        message: _zod.z.string(),
        timestamp: _zod.z.date()
    })).optional(),
    /** The number of users connect to PY from the integration system. */ connectedEmployeesCount: _zod.z.number().optional(),
    /** The name of the specific integration ex: bamboo-hr, adp-wfn etc. */ integrationName: _integration.IntegrationName
});
const IntegrationLog = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    /** The ObjectId of the company the log belongs to. **/ company_id: _zod.z.instanceof(_bson.ObjectId),
    /** Object used to store data related to the ConnectIntegrationWorkers job. **/ connect_worker_properties: _zod.z.object({
        numUsersAttemptedToSync: _zod.z.number().optional()
    }).optional(),
    /** Array of created user ids represented as strings. **/ created_users: _zod.z.array(_zod.z.string()).optional(),
    /** Object used to store settings related to importing data from a csv file. **/ csv_properties: IntegrationLogCsvProperties.optional(),
    /** The count of updates found by our ingest engine. **/ dataIngestFieldCount: _zod.z.number().optional(),
    /** An array of errors that occurred during the job. **/ errors: _zod.z.array(_zod.z.string()).optional(),
    /** Count of employees fetched from the integration. **/ fetchedEmployees: _zod.z.number().optional(),
    /** The time the job finished can be null if the job is still running. **/ finished_at: _zod.z.date().nullable(),
    /** The type of integration the log is for.**/ integration_type: _integration.IntegrationType,
    /** Properties of the integration. **/ integrationProperties: IntegrationLogProperties.optional(),
    /** The number of new users found in the integration system that we created integration users for. **/ newIntegrationWorkers: _zod.z.number().optional(),
    numUsersAttemptedToSync: _zod.z.number().optional(),
    requires_approval_to_deactivate: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    sftp_properties: IntegrationLogSftpProperties.optional(),
    start_at: _zod.z.date(),
    updatedIntegrationWorkers: _zod.z.number().optional(),
    user_updates: _zod.z.array(IntegrationLogUserUpdates),
    users_created: _zod.z.number().optional(),
    users_deactivated: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).optional(),
    users_failed_sync: _zod.z.number(),
    users_successfully_synced: _zod.z.number(),
    users_with_no_changes: _zod.z.number(),
    is_processing: _zod.z.boolean().optional(),
    deactivation_updates: _zod.z.array(_zod.z.object({
        rawValue: _zod.z.string(),
        fieldID: _zod.z.instanceof(_bson.ObjectId),
        userID: _zod.z.instanceof(_bson.ObjectId),
        updaterID: _zod.z.string(),
        comment: _zod.z.string()
    })).optional(),
    /**
	 * Array of emails that have multiple employee records.
	 * Some HRIS systems allow for multiple employment records per employee.
	 * This field is used to track employees that have multiple employment records without manual selection.
	 **/ duplicate_employee_emails: _zod.z.array(_zod.z.string()).nullish()
});
